module.exports = __webpack_public_path__ + "img/logo-red-gradiente-6x.4b8b63e2.png";